/* ==========================================================================
   SpotMyStuff — Use-Case Carousel section
   Arrow-driven scrollBy on the use-case track. Reproduces the handoff's
   own script.js carousel behavior exactly (same step distance, same
   Math.min(step, clientWidth * 0.85) formula, same smooth scrollBy) —
   no slider library, no autoplay, no index state. The track itself is
   natively swipeable/scrollable (CSS scroll-snap) independent of these
   buttons; this script only wires the two arrow buttons to it.

   Follows the same per-section, self-contained IIFE pattern as the
   other SpotMyStuff section scripts (e.g. spotmystuff-problem.js) —
   scoped entirely to `.spotmystuff-usecases`, no shared state or globals,
   nothing here can conflict with another section's JS.

   Two pairs of prev/next buttons share the same data-spotmystuff-
   usecases-prev/next hooks: the round header arrows (desktop/tablet)
   and the bare chevrons overlaid on the track's edges (mobile-only,
   CSS-toggled). Only one pair is ever visible per viewport, but both
   are wired here with querySelectorAll so whichever pair is showing
   works without any viewport-detection logic in JS.

   The mobile chevrons additionally hide themselves at the ends of the
   track — prev hidden on the first card, next hidden on the last card
   — tracked via the track's own scrollLeft against its scrollWidth, so
   it stays correct through native swiping as well as button clicks, not
   just an internal "current index" the script would have to maintain.
   This only applies to the mobile chevrons (targeted by class, not the
   shared data attribute): the header arrows keep the handoff's original
   always-visible behavior on desktop/tablet.
   ========================================================================== */

(function () {
  'use strict';

  var STEP = 360;
  var EDGE_THRESHOLD = 4;

  function initCarousel(root) {
    var track = root.querySelector('[data-spotmystuff-usecases-track]');
    var prevBtns = root.querySelectorAll('[data-spotmystuff-usecases-prev]');
    var nextBtns = root.querySelectorAll('[data-spotmystuff-usecases-next]');
    var mobilePrev = root.querySelector('.spotmystuff-usecases__chevron--prev');
    var mobileNext = root.querySelector('.spotmystuff-usecases__chevron--next');
    if (!track) return;

    function scrollByDir(dir) {
      var distance = Math.min(STEP, track.clientWidth * 0.85);
      track.scrollBy({ left: dir * distance, behavior: 'smooth' });
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { scrollByDir(-1); });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { scrollByDir(1); });
    });

    if (mobilePrev || mobileNext) {
      var updateEdges = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= EDGE_THRESHOLD;
        var atEnd = track.scrollLeft >= maxScroll - EDGE_THRESHOLD;
        if (mobilePrev) mobilePrev.classList.toggle('is-hidden', atStart);
        if (mobileNext) mobileNext.classList.toggle('is-hidden', atEnd);
      };
      track.addEventListener('scroll', updateEdges, { passive: true });
      window.addEventListener('resize', updateEdges);
      updateEdges();
    }
  }

  function init() {
    var sections = document.querySelectorAll('.spotmystuff-usecases');
    sections.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
